/**
 * What to tell the server about SIP when a socket comes back.
 *
 * Two registrations can exist on one phone — JsSIP in the WebView and, on
 * iOS, LinPhone natively — and they are tracked apart on the server, because
 * a native registration outlives the app going to the background and a
 * WebView one does not. The re-statement on reconnect used to send ONE flag
 * under the platform's name: on iOS the JsSIP state went out labelled
 * «native», wiping the server's knowledge of a LinPhone that was registered
 * all along, and the phone was offered no SIP calls (03.09.2026).
 */
export function sipStatusReports({ web = false, native = null } = {}) {
  const out = [{ type: 'sip_status', registered: !!web, native: false }];
  if (native !== null) out.push({ type: 'sip_status', registered: !!native, native: true });
  return out;
}
